import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import iconTypes, { IconNameWithoutSuffix } from './IconTypes';
const IconWrapper = styled.span `
  padding: 0;
  margin: 0;
  font-size: ${(props) => props.size}px;
`;
export const Icon = (props) => {
    const icon = iconTypes[props.iconType];
    return (React.createElement(IconWrapper, Object.assign({}, props),
        React.createElement(FontAwesomeIcon, { icon: icon })));
};
export const StateIcon = (props) => {
    const iconNameWithoutSuffix = IconNameWithoutSuffix(props.iconType);
    return (React.createElement(IconWrapper, Object.assign({}, props),
        React.createElement(FontAwesomeIcon, { icon: props.selected ? iconTypes[(iconNameWithoutSuffix + "Solid")] : iconTypes[(iconNameWithoutSuffix + "Light")] })));
};
